// extracted by mini-css-extract-plugin
module.exports = {"variables":"\"../../assets/stylesheets/variables.scss\"","borderMediumColor":"#cfcfcf","seaweedColor":"#2daf92","emeraldColor":"#02A07D","ironColor":"#282b2d"};